import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { UserLevels } from '../shared/globals';
import { AuthService } from '../shared/services/auth.service';
import { TreeService } from '../shared/services/tree.service';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsGuard  implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(private router: Router, private treeService: TreeService, private authService: AuthService) { }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  /**
   * canMatch, a nie canLoad - z tego samego powodu, dla ktorego przeszedl na
   * niego TreeSettingsGuard: canLoad sprawdza sie TYLKO wtedy, gdy modul nie
   * jest jeszcze wczytany. Po jednym wejsciu w ustawienia konta modul zostaje
   * w pamieci karty, wiec strażnik przestawal byc wolany - wystarczylo sie
   * wylogowac, zeby wejsc na ekran ustawien bez sesji.
   * canMatch dziala przy KAZDEJ nawigacji.
   */
  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean>|Promise<boolean>|boolean {
    return this.authService.isLoggedIn() ? true : this.router.navigate(['/']);
      /*.pipe(takeUntil(this.ngUnsubscribe), map(result => {
        if (result) {
          if ((result?.membershiplevel === UserLevels.Administrator) || (result?.membershiplevel === UserLevels.SuperAdministrator)) {
            return true;
          }
          else {
            const retUrl = '/notauthorized';
            this.router.navigate([retUrl]);
            return false; //this.router.parseUrl('/tree/testowe/login');
          }
        }
        else {
          const retUrl = '/notauthorized';
          this.router.navigate([retUrl]);
          return false; //this.router.parseUrl('/notauthorized');
        }
      }));*/
  }

}
